import React, { useEffect } from 'react';

import { PayBlock } from './card';

import { PaymentMethodProps } from './payment-method.types';
import { PayPrice } from './styled';

import { currencyToSign } from '../../../helpers/currency';

export const PayWithCrypto: React.FC<PaymentMethodProps> = ({ price, currency, orderID, onPay, onError }) => {
  const sign = currencyToSign(currency);

  const fullPrice = Number(price);

  useEffect(() => {
    const initializeCryptoButton = () => {
      const { cryptopay } = window as NotTyped;

      if (!cryptopay) {
        return;
      }

      cryptopay
        .Button({
          createPayment(actions: NotTyped) {
            return actions.payment.create({
              env: 'production',
              currency: 'EUR',
              // amount should be integer
              // e.g., 100 cents ==> $1.00
              amount: Math.floor(fullPrice * 100),
              description: `Pay for the: "${orderID}"`,

              order_id: orderID,
            });
          },

          onApprove(data: NotTyped, actions: NotTyped) {
            if (typeof onPay === 'function') {
              onPay(actions, data);
            }
          },
          onError() {
            if (typeof onError === 'function') {
              onError();
            }
          },
        })
        .render('#pay-button');
    };

    initializeCryptoButton();
  }, [fullPrice, orderID, onPay, onError]);

  return (
    <>
      <PayBlock className="is-hover-shadow">
        <PayPrice>
          {price} {sign}
        </PayPrice>

        <div id="pay-button" className="text-center" />
      </PayBlock>
    </>
  );
};
